const defaultState = {
  list: [],
  parameters: null,
  isFetching: false,
  serviceCategories: [],
  addonServices: [],
  calendar: [],
  timesheet: null,
};

export default function models(state = defaultState, action) {
  switch (action.type) {
    case 'REQUEST_LIST':
      return Object.assign({}, state, {
        isFetching: true,
        list: [],
      });
    case 'RECEIVE_LIST':
      return Object.assign({}, state, {
        isFetching: false,
        list: action.models,
      });

    case 'REQUEST_PARAMETERS':
      return Object.assign({}, state, {
        isFetching: true,
      });
    case 'RECEIVE_PARAMETERS':
      return Object.assign({}, state, {
        isFetching: false,
        parameters: action.parameters,
      });

    case 'REQUEST_SERVICES':
      return Object.assign({}, state, {
        isFetching: true,
      });
    case 'RECEIVE_SERVICES':
      return Object.assign({}, state, {
        isFetching: false,
        serviceCategories: action.categories,
        addonServices: action.addons,
        priceList: action.priceList,
      });

    case 'REQUEST_CALENDAR':
      return Object.assign({}, state, {
        isFetching: true,
        calendar: [],
      });
    case 'RECEIVE_CALENDAR':
      return Object.assign({}, state, {
        isFetching: false,
        calendar: action.calendar,
      });

    case 'REQUEST_TIMESHEET':
      return Object.assign({}, state, {
        isFetching: true,
        timesheet: null,
      });
    case 'RECEIVE_TIMESHEET':
      return Object.assign({}, state, {
        isFetching: false,
        timesheet: action.timesheet,
      });

    default:
      return state;
  }
}
